import { useNotificationsWs } from './notifications.store';
import { notificationsContext } from './use-notifications-context';

export const NotificationsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <notificationsContext.Provider value={useNotificationsWs()}>
      {children}
    </notificationsContext.Provider>
  );
};
